import type { IconData } from '@stacksjs/iconify-core'

export const square: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M476 16H36a20.023 20.023 0 0 0-20 20v440a20.023 20.023 0 0 0 20 20h440a20.023 20.023 0 0 0 20-20V36a20.023 20.023 0 0 0-20-20m-12 448H48V48h416Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default square
